
export default function LargePanel({ styles }) {
    return (
        <svg width="640" height="430" viewBox="0 0 640 430" fill="none" xmlns="http://www.w3.org/2000/svg"
            className={styles} preserveAspectRatio={"none"}>
            <path
                d="M5 0.5H635C637.485 0.5 639.5 2.51472 639.5 5V364.247C639.5 365.925 638.566 367.464 637.077 368.238L520.324 428.992C519.682 429.326 518.97 429.5 518.246 429.5H5C2.51472 429.5 0.5 427.485 0.5 425V5C0.5 2.51472 2.51472 0.5 5 0.5Z"
                fill="#92AFAE" stroke="#7991C4" />
        </svg>

    )
}